import { getEmbeddedSamplePath } from "../../views/App/urls";
import { FeatureAnchor, SampleAnchor } from "../PaperShared/Sample";

function PatchingGrammar() {
  const modelId = "mini";
  const sampleId = "2028000-P1";
  const embeddedSamplePath = `#${getEmbeddedSamplePath(modelId, sampleId)}`;

  return (
    <section>
      <h4>Patching Grammar</h4>
      <p>
        In <SampleAnchor modelId="mini" sampleId="2028000-P1" text="Sample 2028000" />, the next
        token is predicted to be a verb. Substituting{" "}
        <FeatureAnchor modelId="mini" sampleId="2028000" featureKey="4.2.2863" /> with{" "}
        <FeatureAnchor modelId="mini" sampleId="2028000-P1" featureKey="4.2.787" /> on the “uses”
        token shifts downstream activations, strengthening features that support the formation of
        noun phrases while weakening those tied to infinitives. After patching, “the” becomes the
        most likely next token.
      </p>
      <figure>
        <figcaption>
          <span>
            Patched Activations for{" "}
            <SampleAnchor modelId="mini" sampleId="2028000-P1" text="Sample 2028000" />
          </span>
        </figcaption>
        <iframe title="Embedded Circuit" src={embeddedSamplePath} height="410px" />
      </figure>
    </section>
  );
}

export { PatchingGrammar };
